import { render, staticRenderFns } from "./DeleteOrdersByDateDialog.vue?vue&type=template&id=f65cf0b2"
import script from "./DeleteOrdersByDateDialog.vue?vue&type=script&lang=js"
export * from "./DeleteOrdersByDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports